import glslRectSDF from '@resn/gozer-glsl/sdf/sdRect.glsl';

import glslScale from '@/libs/lygia/space/scale.glsl';

export const shaderChunks = {
    uniforms: () => ({
        uHeartbeatPr: { value: 0 },
    }),
    funcs: /* glsl */ `
        

        ${glslScale}
        ${glslRectSDF}

        vec3 preRevealIrri(vec2 uv, float outlineScaleIn, sampler2D tMatcapIrri, vec3 normal, vec3 viewPosition, float matcapRotation, float matcapScale) {
            vec2 outlineUv = scale(uv, vec2(0.9));
            vec2 outlineScale = vec2(0.98, 1.0) * outlineScaleIn;
            float outline = 1.0 - fill(sdRect(outlineUv, outlineScale, -0.95), 1.0);

            vec3 matcapColor = matcap(tMatcapIrri, normal, viewPosition, false, 1.0, 1.0, 0., matcapRotation, matcapScale);
            
            // vec3 finalColor = mix(matcapColor*0.4, matcapColor, outline);
            vec3 finalColor = matcapColor;

            return finalColor;
        }

        // vec3 preRevealIrri(vec2 vUv, float outlineScaleIn) {
        //     return preRevealIrri(vUv, outlineScaleIn);
        // }
    `,
};
